import { SortOrderEnum, SortTypeEnum } from '../typings';

function createSortValue(
    sortBy: SortTypeEnum,
    sortOrder: SortOrderEnum,
): string {
    return `${sortBy}-${sortOrder}`
}

export default {
    createSortValue,
}
